<template>
  <div class="select-use-list">
    <van-popup v-model="showPopup" round position="bottom">
      <div class="select-use-list-content">
        <div class="title">
          <div class="title-left" @click="hidePopup">
            <img
              style="height: 16px; margin-right: 8px"
              src="@/assets/style/left-pupot.png"
              alt=""
            />
          </div>
          <span class="title-text">借款用途</span>
        </div>
        <div class="application-list">
          <van-radio-group v-model="radio" @change="handleChange">
            <div
              v-for="item in applicationList"
              :key="item.value"
              class="application-item"
            >
              <div class="left">
                <img :src="item.icon" alt="" />
                <span class="span">{{ item.name }}</span>
              </div>
              <div class="right">
                <van-radio checked-color="#1d70f7" :name="item.name" />
              </div>
            </div>
          </van-radio-group>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { applicationList } from "@/utils/const";
export default {
  name: "SelectUseList",
  data() {
    return {
      showPopup: false,
      applicationList,
      isChecked: false,
      radio: '个人消费',
    };
  },
  async mounted() {},
  methods: {
    //处理点击事件
    handleChange(item) {
      this.radio = item;
      this.$store.commit("setBorrowPurpose", item);
      this.hidePopup();
    },
    init() {
      this.showPopup = true;
    },
    hidePopup() {
      this.showPopup = false;
    },
  },
};
</script>

<style scoped lang="scss">
.select-use-list {
  .select-use-list-content {
    padding: 16px;
    min-height: 520px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      color: #333333;
      position: relative;
      .title-left {
        display: flex;
        align-items: center;
        width: 50px;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 55%;
        transform: translateY(-50%);
      }
      .title-text {
        flex: 1;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
      }
      .add-bank-card {
        font-size: 13px;
        color: #1d70f7;
        height: 30px;
        border-radius: 44px;
        border: 1px solid #1d70f7;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 6px;
      }
    }
    .application-list {
      margin-top: 15px;
      padding: 0px 8px;
      .application-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding: 17px 0px;
        position: relative;
        .left {
          display: flex;
          align-items: center;
          color: #333333;
          img {
            width: 34px;
            height: 34px;
            margin-right: 8px;
          }
        }
        .right{
          position: absolute;
          width: 100%;
          height: 100%;
          right: 0;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          ::v-deep{
            .van-radio{
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: flex-end;
              align-items: center;
            }
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid #c9c9c9;
  border-radius: 50%;
  margin-right: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  flex-shrink: 0;

  &:checked {
    background-color: #1d70f7;
    border: none;
    &::after {
      content: "";
      width: 8px;
      height: 4px;
      border: 2px solid #fff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg);
      margin-top: -2px;
    }
  }
}
</style>
